import React, { useState } from "react";
import API from "../../config/config";
import ProductMediaWidgetInfo from "./ProductMediaVideo";
import ProductFaq from "./ProductFaq";
import { Col, Row } from "react-bootstrap";

const ProductMediaWidget = ({ data, template, landing }: any) => {
  const btnOne = data.ActionButtons[0];
  const btnTwo = data.ActionButtons[1];
  const BtnDes = {
    btn: 1,
    url: landing ?  btnOne.media.url : btnTwo.media.url,
    description: landing ?  btnOne.description : btnTwo.description,
  };
  const [state, setstate]: any = useState({
    active: BtnDes,
  });

  const toggleVideo = (url: string, btn: number, des: string, id: string) => {
    const video: any = document.getElementById(id);
    video.currentTime = 0;
    setstate({ active: { btn: btn, url: url, description: des } });
  };

  const getClass = (btn: number) => {
    return btn === state.active.btn ? "show" : "hide";
  };

  const getBtnOrder = (template: string) => {
    if (template === "left") {
      return 1;
    }
    return 2;
  };

  return (
    data &&
    state.active && (
      <div
        className={`media-widget-contatiner ${
          landing && `media-widget-contatiner-video`
        }`}
      >
        <div className={`${landing && `media-widget-wrapper`}`}>
          <Row lg={2} sm={1} xs={1}>
            <Col
              sm={{
                order: template ? getBtnOrder(template?.contentAlignment) : 1,
              }}
              className={`media-col-one ${landing && `landing-video-wrapper`}`}
            >
              {!landing && <h1>{data.title}</h1>}
              {!landing && <h2>{data.subTitle}</h2>}
              {landing && (
                <div
                  className="video-title mb-title"
                  dangerouslySetInnerHTML={{ __html: data.title }}
                />
              )}
              <div className="button-text-container">
                <div className="button-container">
                  <button
                    id="btn-1"
                    onClick={() => {
                      toggleVideo(
                        btnOne.media.url,
                        1,
                        btnOne.description,
                        "video1"
                      );
                    }}
                    style={{
                      backgroundImage: `url(${
                        btnOne.buttonBackroundImage
                          ? API.baseUrl + btnOne.buttonBackroundImage.url
                          : ""
                      })`,
                    }}
                    className={
                      state.active && state.active.btn === 1 ? "active" : ""
                    }
                  >
                    {btnOne.buttonLabel}
                  </button>
                  <div className="divider" />
                  <button
                    id="btn-2"
                    style={{
                      backgroundImage: `url(${
                        btnTwo.buttonBackroundImage
                          ? API.baseUrl + btnTwo.buttonBackroundImage.url
                          : ""
                      })`,
                    }}
                    onClick={() => {
                      toggleVideo(
                        btnTwo.media.url,
                        2,
                        btnTwo.description,
                        "video2"
                      );
                    }}
                    className={
                      state.active && (state.active.btn === 2 ? "active" : "")
                    }
                  >
                    {btnTwo.buttonLabel}
                  </button>
                </div>
                {!landing && (
                  <div
                    className="des"
                    dangerouslySetInnerHTML={{
                      __html: state.active.description,
                    }}
                  />
                )}
                {landing && (
                  <ProductMediaWidgetInfo
                    getClass={getClass}
                    btnOne={data?.ActionButtons[0]}
                    btnTwo={data?.ActionButtons[1]}
                  />
                  
                )}
                  {/* 
                    Temp Fix
                    @TODO: refactor h4 to always display under video
                  */}
                  {landing &&
                    <h4 className='video-new-content-caption' dangerouslySetInnerHTML={{ __html: state.active.description }}/>
                  }

              </div>
            </Col>
            <Col
              sm={{
                order: template ? getBtnOrder(template?.contentAlignment) : 2,
              }}
              className={`${!landing && `media-col-two`}`}
            >
              {!landing ? (
                <ProductMediaWidgetInfo
                  getClass={getClass}
                  btnOne={data?.ActionButtons[0]}
                  btnTwo={data?.ActionButtons[1]}
                  btnState={state.active.description}
                />
              ) : (
                <ProductFaq data={data} />
              )}
            </Col>
          </Row>
          {!landing && (
            <div
              className={"mobile-des"}
              dangerouslySetInnerHTML={{ __html: state.active.description }}
            />
          )}
        </div>
      </div>
    )
  );
};

export default ProductMediaWidget;
